import {fromJson, URL_BASE_AUTH} from "../utils/helper.js";


class ShortcutLinkItemModel {


    constructor() {

        this.id = null;
        this.module = null
        this.route = null
        this.parameters = []
        this.shortcut_link_id = null
        this.moduleAttributes = []

    }


    static fromJson(object) {
        return fromJson((new ShortcutLinkItemModel()), object);
    }


}

export default ShortcutLinkItemModel;
